import { Block } from 'baseui/block'
import { IoCalendarOutline } from 'react-icons/io5'
import { themedUseStyletron } from '../../../theme/customTheme'
import { StateText } from './StateText'
import { IScheduler } from './types'

export function SmallPanel(props: IScheduler) {
    const [css, theme] = themedUseStyletron(); 

    return (
        
        <Block display='flex' flexDirection='row' alignItems='center' justifyContent='center' gridGap='5px'>
              <IoCalendarOutline className={css({
                fontSize: '30pt',
                color: theme.colors.accent500
            })}   />
            { 
            <StateText {...props}></StateText>}
        </Block>
    );
}
